import { render, staticRenderFns } from "./courer.vue?vue&type=template&id=49d580b4&scoped=true"
import script from "./courer.vue?vue&type=script&lang=js"
export * from "./courer.vue?vue&type=script&lang=js"
import style0 from "./courer.vue?vue&type=style&index=0&id=49d580b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d580b4",
  null
  
)

export default component.exports